<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>
    <Form :data="entry" @save="save" />
  </div>
</template>

<script>
import ZHeader from '../../layout/Header';
import Form from './Form.vue';
import restrictions from '../../services/restrictions';

export default {
  data() {
    return {
      title: 'Adicionar restrição',
      actions: [
        {
          label: 'Voltar',
          route: '/configuracoes',
        },
      ],
      entry: {
        title: '',
        dailyAmount: '',
        weeklyAmount: '',
        monthlyAmount: '',
      },
      isLoading: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {},
    async save(rawData) {
      try {
        await restrictions.create(rawData);

        this.$router.push({
          name: "settings"
        });
      } catch (err) {
        console.error(err);

        this.$buefy.toast.open({
          message: 'Erro ao salvar o grupos de restrições',
          type: 'is-danger',
        });
      }
    },
  },
  components: {
    ZHeader,
    Form,
  },
};
</script>

<style lang="scss"></style>
